export type SET_PREVIEW_IMAGE_SRC = 'SET_PREVIEW_IMAGE_SRC';
export const SET_PREVIEW_IMAGE_SRC: SET_PREVIEW_IMAGE_SRC = 'SET_PREVIEW_IMAGE_SRC';

export type SHARE_IMAGE = 'SHARE_IMAGE';
export const SHARE_IMAGE: SHARE_IMAGE = 'SHARE_IMAGE';

export type SET_SHARED_IMAGE = 'SET_SHARED_IMAGE';
export const SET_SHARED_IMAGE: SET_SHARED_IMAGE = 'SET_SHARED_IMAGE';

export type SET_IS_LOADING = 'SET_IS_LOADING';
export const SET_IS_LOADING: SET_IS_LOADING = 'SET_IS_LOADING';
